import { RED } from "../../../../constants/colors";

// BrandPerformanceTrendChart.tsx already honors an optional `colour` field on each seriesList
// entry (the exact mechanism it uses today to keep pre/post line-cut segments visually
// consistent), falling back to its SOV_MIX_COLORS-by-position palette otherwise - no chart
// changes needed, just populate `colour` on the right entry before it reaches the chart.
//
// Normalizes away casing/hyphenation/leading-underscore (line-cut segments are prefixed with "_")
// so this matches whatever exact form a future real backend response uses for the series name -
// e.g. "ePower", "e-Power", "E_POWER", or a line-cut segment "_ePower" all match.
const isEPower = (label: string | undefined) =>
  (label ?? "")
    .replace(/^_+/, "")
    .replace(/[^a-z]/gi, "")
    .toLowerCase() === "epower";

export interface TechAwarenessSeriesEntry {
  name: string;
  field: string;
  colour?: string;
}

export const applyEPowerSeriesColor = (series: TechAwarenessSeriesEntry[] | undefined): TechAwarenessSeriesEntry[] | undefined =>
  series?.map((entry) => (isEPower(entry.name) || isEPower(entry.field) ? { ...entry, colour: RED } : entry));
